<template>
    <div class="container-fluid mt-2" style="font-family:'Courier New'">
        <div class="row">
          <div class="col-2">
            <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="100"/></span>
            <span v-else><img src="@/assets/images/logo.png" height="100"/></span>
          </div>
          <div class="col-7 mt-2">
            <h2 style="color:black;font-weight: 700; " class="text-uppercase mb-1">{{ userData.business }}</h2>
            <b style="color:black;font-size:12px">Location: {{ userData.location }}</b><br>
            <b style="color:black;font-size:12px">Contacts: {{ userData.contact }}</b><br>
            <b style="color:black;font-size:12px">E-mail: {{ userData.email }}</b><br>
            <b style="color:black;font-size:12px">Website: {{ userData.website }}</b>
          </div>
          <div class="col-3 mt-3">
            <span style="color:black;font-size:13px;font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;"> Visit ID: <br> <b style="font-size: 20px;"> {{ this.visitid }}</b></span>
          </div>
        </div>
        <hr style="border: 1px solid black;">
                
        <center><span style="color: black;font-family: tahoma;font-size:13px" class="text-decoration-underline"><b> PAYMENT LEDGER</b></span></center>
      <br><div v-for="item in patients" :key="item.id" class="d-flex justify-content-between">
      <span> Name: <b class=" h6">{{ item.name }} </b></span>
      <span> Patient ID: <b class=" h6">{{ item.patient_id }} </b></span>
      <span> Sex: <b class=" h6">{{ item.gender }} </b></span>
      <span> Telephone: <b class=" h6">0{{ item.telephone }} </b></span>
      </div>

    <span v-if="services.length">
    <h5 >Services</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
      <thead><tr><th>Category</th><th>Service Name</th><th>Price</th></tr></thead>
      <tbody>
        <tr v-for="item in services" :key="item.id">
            <td>{{ item.service_category.name }} </td>
            <td>{{ item.service_name.name }}</td>
            <td>{{ item.service_price }}</td>
        </tr>
      </tbody>
      </table>
    </span>
        <span v-if="prescriptions.length">
          <h5>Presciptions</h5>
            <table class="table table-sm" style="color: black;" density="compact">
            <thead><tr><th>Medicine</th><th>Quantity</th><th>Price</th></tr></thead>
            <tbody>
                <tr v-for="item in prescriptions" :key="item.id">
                <td>{{ item.medicine.name }} </td>
                <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                <td>{{ item.totalprice }}</td>
                </tr>
            </tbody>
            </table>
        </span>
        
        <span v-if="consumables.length">
        <h5 >Consumables</h5>
          <table class="table table-sm mt-n2" style="color: black;" density="compact">
          <thead><tr><th>Consumable</th><th>Quantity</th><th>Price</th></tr></thead>
          <tbody>
              <tr v-for="item in consumables" :key="item.id">
              <td>{{ item.consumbale.name }} </td>
              <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
              <td>{{ item.totalprice }}</td>
              </tr>
          </tbody>
          </table>
        </span>
        
        <span v-if="payments.length">
        <h5 >Payments</h5>
        <table class="table table-sm mt-n2" style="color: black;" density="compact">
        <thead><tr><th>Pay Date</th><th>Amount Paid Time</th><th>Payment Type</th></tr></thead>
        <tbody>
          <tr v-for="item in payments" :key="item.id">
              <td>{{ item.pay_date }}</td>
              <td>{{ commas(item.amount_paid) }}</td>
              <td>
                <span v-if="item.payment_type==1">Cash</span>
                <span v-else>Account</span>
              </td>
          </tr>
        </tbody>
        </table>
        </span>

      <div class="mt-2 text-center">
        <span style="color: black;font-size:14px"><b> AMOUNT PAID : {{commas(amount_paid)}}</b></span><br>
        <span style="color: black;font-size:14px"><b> PENDING BALANCE : {{commas(balance)}}</b></span><br>
        <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
        <br> On : {{ new Date().toLocaleString() }}
        <br>Thanks for Supporting Us. <br> 
       </p>

       <barcode :value="this.visitid" height="50" display-value="false"></barcode>

    </div>
    </div>
</template>

<script>
import axios from "axios";
import VueBarcode from 'vue-barcode';

export default {
  components: { 'barcode': VueBarcode },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:[],
      payments:[],
      services:[],
      patientid:'',
      visitid:'',
      consumables:[],
      prescriptions:[],
      amount_paid:0,
      balance:0,
    }
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    async fetchInfo(){
      this.id=this.$route.query.id;
      let url = `/legderinfo/${this.id}`;
      await axios.get(url).then((response) => {
        this.patientid = response.data.visits[0].patient.patient_id;
        this.visitid = response.data.visits[0].visit_id;
        this.showpatient();
      });
    },
    async showpatient(){
      let url = `/patientprofile/${this.patientid}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
        this.showpayments();
        this.showservices();
        this.showtprescriptions();
        this.showtconsumables();
        this.showbalances();
      });
    },
    async showservices(){
      let url = `/profileservices/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.services = response.data.visits;
      });
    },
    
    async showtconsumables(){
      let url = `/profileconsumables/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.consumables = response.data.consumables;
      });
    },
    async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
    async showpayments(){
      let url = `/legdgerpayments/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.payments = response.data.payments;
      });
    },
    async showbalances(){
      let url = `/invoicepayments/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.amount_paid = response.data.payments[0].paid;
        this.balance = response.data.payments[0].balance;

        setTimeout(() => { window.print(); window.onafterprint=this.$router.go(-1); }, 1000);
      });
    },
  },
  };
</script>